import type { AggregateBlueprint } from './AggregateBlueprint';
import { instanceOfAggregateBlueprint } from './AggregateBlueprint';

export interface RootBlueprint extends AggregateBlueprint
{
    root: true;
    componentNames: { name: string; type: string }[];
}

export const instanceOfRootBlueprint = (object: any): object is RootBlueprint =>
{
    return instanceOfAggregateBlueprint(object) && 'root' in object && object.root === true;
};

export abstract class RootAbstract
{
    public root: true = true as const;
}
